import React, { FC, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { Menu, MenuProps } from "../../components/common";
import { ROUTES } from "../../routes";
import { useLogoutMutation } from "../../store/services/auth";
import { selectCurrentUser } from "../../store/reducers/user";
import { AccountType } from "../../types/UserTypes";

type Props = Omit<MenuProps, "list" | "active">;

export const ProfileMenu: FC<Props> = (props) => {
  const navigate = useNavigate();
  const { direction } = props;
  const location = useLocation();
  const [logout] = useLogoutMutation();
  const { account_type } = useSelector(selectCurrentUser);

  const invoiceDetailsLabel =
    account_type === AccountType.CONTRACTOR ? "Invoice details" : "Company";

  const MenuList = useMemo(() => {
    const logoutHandler = async (e: any) => {
      await logout(e);
      navigate(ROUTES.AUTH_LOGIN);
    };

    const options = [
      {
        key: "general",
        icon: "Home",
        name: "General",
        to: ROUTES.PROFILE_GENERAL,
      },
      {
        key: "profile_invoice",
        icon: "Payments",
        name: invoiceDetailsLabel,
        to: ROUTES.PROFILE_INVOICE,
      },
      {
        key: "profile_contacts",
        icon: "Mail",
        name: "Email and phone",
        to: ROUTES.PROFILE_CONTACTS,
      },
      {
        key: "security",
        icon: "Lock",
        name: "Security",
        to: ROUTES.PROFILE_SECURITY,
      },
      {
        key: "logout",
        icon: "Log-out",
        name: "Logout",
        onClick: logoutHandler,
      },
    ];

    if (direction === "horizontal") {
      options.splice(2, 1);
      return options.slice(0, 3);
    }

    return options;
  }, [invoiceDetailsLabel, direction, logout, navigate]);

  return <Menu {...props} list={MenuList} active={location.pathname} />;
};
